// extracted by mini-css-extract-plugin
module.exports = {"container":"Feature_container__1kzGJ","text":"Feature_text__33r3-"};